import React, { useState } from "react";
import TimeoutProvider, { resetTimeout } from "./TimeoutProvider";
import axios from "axios";
import MessageBox from "../../components/MessageBox";

const testConnection = async () => {
  try {
    await axios.get("/api/Branches?ts=" + new Date().getTime());
  } catch (err) {
    if (err.message === "Network Error") {
      document.location.href = "/";
    }
  }
};

export default (props: any) => {
  const [message, setMessage] = useState<string>("");

  return (
    <TimeoutProvider
      onWarning={() => setMessage("Timing out shortly")}
      onTimeout={async () => {
        await testConnection();
      }}
    >
      {props.children}
      <MessageBox
        message={message}
        severity="warning"
        onClose={() => setMessage("")}
        action={async () => {
          setMessage("");
          await testConnection();
          resetTimeout();
        }}
        actionText="Stay logged in"
      />
    </TimeoutProvider>
  );
};
